export default "__VITE_ASSET__DHR0oykb__"